import { useState, useCallback } from 'react';

/**
 * Custom hook to manage modal state
 * @returns {Object} { isOpen, openModal, closeModal, toggleModal }
 */
export function useModal() {
    const [isOpen, setIsOpen] = useState(false);

    const openModal = useCallback(() => {
        setIsOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setIsOpen(false);
    }, []);

    const toggleModal = useCallback(() => {
        setIsOpen(prev => !prev);
    }, []);

    return {
        isOpen,
        openModal,
        closeModal,
        toggleModal
    };
}
